import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Constants } from './../../Utilities/Constants/constants';

import { Router } from '@angular/router';
import { CommonService } from '../../service/common.service';
import { DataService } from '../../service/data.service';
import { Lead } from '../../model/lead';
import { FormGroup } from '@angular/forms';

import { CreditAuth } from '../../model/credit-auth';
import { CreditAuthService } from '../../service/credit-auth.service';
import { RouterExtService } from '../../service/router-ext.service';
import { ModelPopupComponent } from '../../shared/model-popup/model-popup.component';
import { LeadHistory } from '../../model/leadHistory';

@Component({
  selector: 'app-credit-auth',
  templateUrl: './credit-auth.component.html',
  styleUrls: ['./credit-auth.component.css']
})
export class CreditAuthComponent implements OnInit {
  creditAuthForm: FormGroup;
  LiveChatImage = '';
  AgentPic = '';
  formErrors: any = {};
  leadDetails: Lead;
  isLoading = false;
  isExclude: boolean;
  hideSSN=false;
  @ViewChild(ModelPopupComponent)popUp:ModelPopupComponent;

  constructor(public router: Router,
    public commonService: CommonService,
    public constantsObj: Constants,
    public dataService: DataService,
    public creditAuthService: CreditAuthService,
    private routerExtService: RouterExtService) {
    this.LiveChatImage = constantsObj.LiveChatImage;
  }

  ngOnInit() { 
    this.commonService.ScrollToRTQForm();
    this.commonService.SaveLeadHistory(); 
    this.dataService.leadHistory.pageNumber=2;
    this.leadDetails = this.dataService.leadDetails;
    if (this.leadDetails != null && this.leadDetails.creditAuth == undefined)
      this.leadDetails.creditAuth = new CreditAuth();
      if(this.leadDetails.creditAuth.ssn=='')
      this.hideSSN=false;
      else
      this.hideSSN=true;
  }
  ngOnDestroy() {
    this.dataService.leadDetails = this.leadDetails;
    this.commonService.EmptyLeadObject();
  }
  savePageDetails() {
    this.isLoading = true;
    this.leadDetails.contactMeButtonClicked=true;
    this.hideSSN=true;
    this.commonService.CreateLeadHistoryObj(2,this.leadDetails);
    this.creditAuthService
      .postLeadInfo(this.leadDetails)
      .subscribe((data: Lead) => {
        this.commonService.SaveLeadHistoryFromContactBtn();
        this.leadDetails = data;
        this.isLoading = false;
        this.commonService.NavigateToPage('/real-time-quote/contact');
      }, err => {
        this.isLoading = false;
        this.dataService.handleError(err);
      });
  }
  onSubmit(creditAuthForm) {
    this.dataService.leadHistory.noUpdate=creditAuthForm['form'].pristine;
    this.formErrors = {};
    this.formErrors = this.commonService.updateControls(creditAuthForm);
    if (creditAuthForm.valid) {
      this.commonService.ScrollToRTQForm();
      this.hideSSN=true;
      this.isLoading = true;
      this.creditAuthService
        .postLeadInfo(this.leadDetails)
        .subscribe((data: Lead) => {
          this.leadDetails = data;
          this.isLoading = false;
          this.commonService.NavigateToPage('/real-time-quote/home-info');
        }, err => {
          this.isLoading = false;
          this.dataService.handleError(err);
        });
      return true;
    }
    else {
      if(!creditAuthForm.valid){
        this.commonService.focusFirstInvalidElement();
          return;
      }
    }
  }  
}
